module.exports = require('./readable').Transform



//////////////////
// WEBPACK FOOTER
// ./node_modules/readable-stream/transform.js
// module id = 154
// module chunks = 0